import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading, signOut } = useAuth();
  const [checkingStatus, setCheckingStatus] = useState(true);
  const [accountStatus, setAccountStatus] = useState<string | null>(null);

  useEffect(() => {
    const checkAccountStatus = async () => {
      if (user) {
        const { data: profile, error } = await supabase
          .from("profiles")
          .select("account_status")
          .eq("id", user.id)
          .maybeSingle();

        if (error) {
          if (error.message?.includes("JWT expired")) {
            await signOut();
            return;
          }
        }

        if (profile) {
          setAccountStatus(profile.account_status);
        }
      }
      setCheckingStatus(false);
    };

    checkAccountStatus();
  }, [user]);

  if (loading || checkingStatus) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Block access if account is deleted or scheduled for deletion
  if (accountStatus === "deleted" || accountStatus === "deletion_scheduled") {
    signOut();
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
